import React from 'react';
import './LoginPage.scss';
import image from '../../assets/loginPageImage.jpg';
import strings from '../../resources/strings';
import { Container, Typography, Grid } from '@material-ui/core';
import { Alert } from '@mui/material';
import { LoginForm } from '../../components/LoginForm';
import { useDispatch, connect } from 'react-redux';
import { requestSignInEmailPassword } from '../../store/auth/actions';
import { AppState } from '../../store/rootReducer';
import { getError } from '../../store/auth/selectors';
import LoginInterface from './types';

const LoginPage: React.FC<LoginInterface> = (props) => {
    const dispatch = useDispatch();

    const handleSignIn = (email: string, password: string) => {
        const user = { email, password };
        dispatch(requestSignInEmailPassword(user));
    };
    return (
        <Grid container className="mainContainer">
            <Grid item sm={5}>
                <Container component="main" maxWidth="md">
                    <div className="paper">
                        <Typography component="h1" variant="h1" className="header">
                            {strings.loginPage.header}
                        </Typography>
                        <Container component="main" maxWidth="sm" className="loginForm">
                            <Typography component="h1" variant="h5">
                                {strings.loginPage.title}
                            </Typography>
                            <LoginForm onSubmit={handleSignIn} />
                            {props?.error ? (
                                <Alert variant="outlined" severity="error">
                                    {props.error}
                                </Alert>
                            ) : (
                                ''
                            )}
                        </Container>
                    </div>
                </Container>
            </Grid>
            <Grid item sm={7}>
                <img src={image} className="image"></img>
            </Grid>
        </Grid>
    );
};

function mapStateToProps(state: AppState) {
    return {
        error: getError(state),
    };
}

export default connect(mapStateToProps)(LoginPage);
